import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PostRenewalInformationEffects } from './effects';
import { featureKey, reducer } from './reducer';
import { PostRenewalInformationService } from './service';

@NgModule({
  imports: [EffectsModule.forFeature([PostRenewalInformationEffects]), StoreModule.forFeature(featureKey, reducer)],
  providers: [PostRenewalInformationService],
})
export class PostRenewalInformationModule {}
